// eslint-disable-next-line no-unused-vars
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import boonApi from './boon.api';
// import togglePublishedState from '~/api/togglePublishedState.api';
import { alertSwal } from '~/utils/helpers';
import { handleThunkException } from '~/services/thunk.service';

export const fetchBoonApi = createAsyncThunk(
    'heroSaga/boon/fetchBoonApi',
    async (navigate, { dispatch, rejectWithValue }) => {
        try {
            dispatch(requestStarted());
            const data = await boonApi.index();
            if (data) {
                dispatch(requestFinished());
                return data;
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue([]);
        }
    },
);

// export const toggleBoonPublishedStateApi = createAsyncThunk(
//     'heroSaga/boon/toggleBoonPublishedStateApi',
//     async (id, { dispatch, rejectWithValue }) => {
//         try {
//             await togglePublishedState(id);

//             return id;
//         } catch (error) {
//             handleThunkException(error, dispatch);

//             return rejectWithValue();
//         }
//     },
// );

// export const createBoonApi = createAsyncThunk(
//     'heroSaga/boon/createBoonApi',
//     async (navigate, { dispatch }) => {
//         try {
//             dispatch(requestStarted());
//             const { data } = await boonApi.create();

//             return data;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);
//         } finally {
//             dispatch(requestFinished());
//         }
//     },
// );

// export const storeBoonApi = createAsyncThunk(
//     'heroSaga/boon/storeBoonApi',
//     async (params, { dispatch, rejectWithValue }) => {
//         const { navigate, values } = params;

//         try {
//             dispatch(requestStarted());
//             const hero = await boonApi.store(values);
//             alertSwal('success', 'Boon created successfully!');

//             return hero;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);

//             return rejectWithValue();
//         } finally {
//             dispatch(requestFinished());
//         }
//     },
// );

export const showBoonApi = createAsyncThunk(
    'boonSaga/boon/showBoonApi',
    async (params, { dispatch, rejectWithValue }) => {
        const { id, navigate } = params;

        try {
            dispatch(requestStarted());
            const { data } = await boonApi.show(id);

            return data;
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue();
        } finally {
            dispatch(requestFinished());
        }
    },
);

export const updateBoonApi = createAsyncThunk(
    'heroSaga/boon/updateBoonApi',
    async (params, { dispatch, rejectWithValue }) => {
        const { navigate, id, values } = params;

        try {
            dispatch(requestStarted());
            await boonApi.update(id, values);
            alertSwal('success', 'Boon updated successfully!');

            return values;
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue([]);
        } finally {
            dispatch(requestFinished());
        }
    },
);

// export const deleteBoonApi = createAsyncThunk(
//     'heroSaga/boon/deleteBoonApi',
//     async (params, { dispatch }) => {
//         const { navigate, id } = params;

//         try {
//             await boonApi.delete(id);

//             return id;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);
//         }
//     },
// );

export const boonSlice = createSlice({
    name: 'heroSaga/boon',
    initialState: { rows: [], model: {}, editedModel: {}, adventureCategories: [] }, //model is initialValues that are used for formik.
    reducers: {
        clearEditedBoon(state) {
            state.editedModel = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBoonApi.fulfilled, (state, { payload }) => {
                return {
                    ...state,
                    rows: payload,
                };
            })
            .addCase(fetchBoonApi.rejected, (state, { payload = [] }) => {
                state.rows = payload;
            });

        // builder
        //     .addCase(toggleBoonPublishedStateApi.fulfilled, (state, { payload }) => {
        //         const updateRow = state.rows.find((row) => row.id === payload);
        //         updateRow.isReady = !updateRow.isReady;
        //     })
        //     .addCase(toggleBoonPublishedStateApi.rejected, () => {
        //         console.log('🚀 ~ rejected');
        //         //do nothing
        //     });

        // builder.addCase(createBoonApi.fulfilled, (state, { payload }) => {
        //     state.model = payload.model;
        // });

        // builder
        //     .addCase(storeBoonApi.fulfilled, (state) => {
        //         return {
        //             ...state,
        //             rows: [], //clear all rows so that api fetchAll will be called again in index page.
        //         };
        //     })
        //     .addCase(storeBoonApi.rejected, () => {
        //         //do nothing so that state will remain intact and component will not re-render.
        //     });

        builder
            .addCase(showBoonApi.fulfilled, (state, { payload }) => {
                state.editedModel = payload.model;
                state.adventureCategories = payload.adventureCategories;
            })
            .addCase(showBoonApi.rejected, () => {
                //
            });

        builder
            .addCase(updateBoonApi.fulfilled, (state, { payload }) => {
                state.editedModel = payload; //this is to make Update component re-render so that the checkDuplicateName() will have the latest `initialName`.
                if (state.rows.length === 0) return;

                const updatedRow = state.rows.find((row) => row.id === payload.id);
                updatedRow.name = payload.name;
                updatedRow.description = payload.description;
                updatedRow.activeRounds = payload.activeRounds;
                updatedRow.activeTurns = payload.activeTurns;
                updatedRow.adventureCategory = state.adventureCategories.find(
                    (item) => payload.adventureCategoryId === item.id,
                );
            })
            .addCase(updateBoonApi.rejected, () => {
                //
            });

        // builder.addCase(deleteBoonApi.fulfilled, (state, { payload }) => {
        //     return {
        //         ...state,
        //         rows: state.rows.filter(({ id }) => id !== payload),
        //     };
        // });
    },
});

export const { clearEditedBoon } = boonSlice.actions;
